import { computed, toValue, type MaybeRefOrGetter } from 'vue';
import { useRoute } from 'vue-router';
import { useRuntimeConfig } from 'virtual:runtime-config';

import { getPathWithoutTag } from '@/entities/filter/store/utils/removeTagFromPath';
import { useSeoStore } from '@/shared/store/useSeoStore';

export const useTagCanonicalLink = (currentTag: MaybeRefOrGetter<string>) => {
  const route = useRoute();
  const seoStore = useSeoStore();
  const { VITE_RUNTIME_CANONICAL_URL } = useRuntimeConfig<false>();

  return computed(() => {
    const tag = toValue(currentTag);

    if (tag === 'all' || tag === '') {
      const url = VITE_RUNTIME_CANONICAL_URL || window.location.origin || 'https://experience.tripster.ru';
      const pathWithoutAll = getPathWithoutTag(route.path, 'all');

      return `${url}${pathWithoutAll}`;
    }

    return seoStore.tagCanonicalUrl;
  });
};
